export const containerStyles =
  'flex flex-col bg-white max-w-lg mx-auto mt-6 p-8 rounded-xl shadow-1';

export const subtitleTextStyle = 'm-0 pb-4 font-medium text-j-dark-600 text-xl';
